import { SecurityInfoResolverActions, SecurityInfoApiActions } from './security-info.actions';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AppleDevicesService } from '@rocksoft/mdm-sdk-v2';
import { filter, mergeMap } from 'rxjs/operators';
import { safeMap } from '../effects.helpers';

@Injectable()
export class SecurityInfoEffects {
  constructor(
    private readonly actions: Actions,
    private readonly appleDeviceService: AppleDevicesService
  ) {}

  securityInfoRequestedEffect$ = createEffect(() => {
    return this.actions.pipe(
      ofType(SecurityInfoResolverActions.securityInfoRequested),
      mergeMap(({ udid }) =>
        safeMap(
          this.appleDeviceService.getSecurityInfo(udid, '2.0').pipe(filter((securityInfo) => securityInfo !== null)),
          (securityInfo) =>
            SecurityInfoApiActions.securityInfoLoaded({
              securityInfo: {
                ...securityInfo,
                udid,
              },
            }),
          (error) => SecurityInfoApiActions.securityInfoLoadedError({ error })
        )
      )
    );
  });
}
